<template>
  <div
    class="osv-alert-message"
    v-bind:class="messageClass()"
    v-if="messages.length > 0"
    v-html="messageText()"
  />
</template>

<script>
export default {
  name: "AlertMessage",
  props: ["messages", "type"],

  methods: {
    messageText: function() {
      if (typeof this.messages === "string") {
        return this.messages;
      }

      if (this.messages.length > 1) {
        let message = `<ul>`;
        for (let item of this.messages) {
          message += `<li>${item}</li>`;
        }
        message += `</ul>`;
        return message;
      } else {
        return this.messages[0];
      }
    },

    messageClass: function() {
      if (typeof (this.messages !== "string") && this.messages.length > 1) {
        return `${this.type} multi-messages`;
      } else {
        return `${this.type} single-message`;
      }
    }
  }
};
</script>

<style lang="scss">
.osv-alert-message {
  padding: 1em 1.5em 1em 1.5em;
  border-left-style: solid;
  border-width: 4px;
  border-radius: 4px;
  margin-bottom: 1em;

  &.single-message {
    text-align: center;
  }

  &.multi-messages {
    text-align: left;
  }

  &.warning {
    color: #947600;
    border-color: #ffdd57;
    background-color: #fffbeb;
  }
  &.danger {
    color: #cc0f35;
    border-color: #f14668;
    background-color: #feecf0;
  }
  &.success {
    color: #257942;
    border-color: #48c774;
    background-color: #effaf3;
  }
  &.info {
    color: #1d72aa;
    border-color: #3298dc;
    background-color: #eef6fc;
  }
}
</style>
